import {
  Component,
  Inject,
  OnDestroy,
  QueryList,
  ViewChild,
  ViewChildren,
} from "@angular/core";
import { MD_DIALOG_DATA, MdDialogRef } from "@angular/material";
import { TranslationService } from "../../services/translation.service";
import { Store } from "@ngrx/store";
import { User } from "../../models/user";
import { Subscription } from "rxjs/Subscription";
import { Translation } from "../../models/translation";
import { Picture } from "../../models/picture";
import { PictureCropperComponent } from "../../components/picture-cropper/picture-cropper.component";
import { PictureService } from "../../services/picture.service";
import {
  ProgramArticleTranslation,
  Destination,
} from "../../models/program-article-translation";
import { ProgramArticle } from "../../models/program-article";
import { ProgramArticlesActions } from "../../store/actions/program-articles.actions";
import { TranslationsActions } from "../../store/actions/translations.actions";
import { AdminService } from "../../services/admin.service";
import { ProgramArticlePictureETTValue } from "../../models/program-article-translation-value";
import { Language } from "../../models/language";
import { Channel } from "../../models/channel";
import { EventArticleService } from "../../services/event-article.service";
import { EventArticlesActions } from "../../store/actions/event-articles.actions";
import { AdditionalPicturesActions } from "../../store/actions/additional-pictures.actions";
import { Types } from "../../models/picture/types";
import { ActivatedRoute } from "@angular/router";
import { EventAdditionalPicturesActions } from "../../store/actions/event-additional-pictures.actions";

@Component({
  selector: "app-cropper-picture-modal",
  templateUrl: "./cropper-picture-modal.component.html",
  styleUrls: ["./cropper-picture-modal.component.scss"],
})
export class CropperPictureModalComponent implements OnDestroy {
  subscriptions: Subscription[];
  translation: Translation | ProgramArticleTranslation;
  picture: Picture;
  // ett
  pictures: ProgramArticlePictureETTValue[];
  file: File;
  newOriginal: string;
  loading: boolean;
  loadingFocalPoint: boolean;
  saving: boolean;
  errorMessage: string;
  fileSize: string;
  selectedIndex: number;
  equinoxeTerm: string;
  programArticle: ProgramArticle;
  editMode: boolean;
  destination: Destination;
  currentLanguage: Language;

  focalPointEnabled: boolean;
  focalPointModeOn: boolean;
  customXPosition: number;
  customYPosition: number;

  is4K: boolean;
  types: Types;

  beamPictureFormats: boolean;

  format: any[];

  MAX_WIDTH: number = 4000;
  MAX_HEIGHT: number = 4000;

  @ViewChild("cropper169") cropper169: PictureCropperComponent;
  @ViewChild("cropper43") cropper43: PictureCropperComponent;
  @ViewChild("cropper34") cropper34: PictureCropperComponent;
  @ViewChild("cropper715") cropper715: PictureCropperComponent;
  @ViewChild("cropper103") cropper103: PictureCropperComponent;
  @ViewChild("cropper11") cropper11: PictureCropperComponent;
  @ViewChild("cropper23") cropper23: PictureCropperComponent;
  @ViewChild("cropper31") cropper31: PictureCropperComponent;
  @ViewChild("cropper140303") cropper140303: PictureCropperComponent;
  @ViewChild("cropper485173") cropper485173: PictureCropperComponent;

  @ViewChildren(PictureCropperComponent)
  croppers: QueryList<PictureCropperComponent>;

  indexes = [
    "Original",
    "16:9",
    "4:3",
    "3:4",
    "7:15",
    "10:3",
    "1:1",
    "2:3",
    "3:1",
    "140:303",
    "216:65",
    "485:173",
  ];

  croppersFormat = [
    "cropper169",
    "cropper43",
    "cropper34",
    "cropper715",
    "cropper103",
    "cropper11",
    "cropper23",
    "cropper31",
    "cropper140303",
    "cropper21665",
    "cropper485173",
  ];
  /**
   * Initialize variables and load data from program article or translation
   * @param {MdDialogRef<CropperPictureModalComponent>} dialogRef
   * @param data
   * @param {TranslationService} translationService
   * @param {PictureService} pictureService
   * @param {TranslationsActions} translationsActions
   * @param {ProgramArticlesActions} programArticlesActions
   * @param {ProgramArticleService} programArticleService
   * @param {AdminService} adminService
   * @param {Store<any>} store
   */
  constructor(
    public dialogRef: MdDialogRef<CropperPictureModalComponent>,
    @Inject(MD_DIALOG_DATA) public data: any,
    private translationService: TranslationService,
    private eventArticleService: EventArticleService,
    private pictureService: PictureService,
    private translationsActions: TranslationsActions,
    private eventArticlesActions: EventArticlesActions,
    private programArticlesActions: ProgramArticlesActions,
    private additionalPicturesActions: AdditionalPicturesActions,
    private eventAdditionalPicturesActions: EventAdditionalPicturesActions,
    private adminService: AdminService,
    private store: Store<any>,
    private route: ActivatedRoute
  ) {
    this.loading = true;
    this.saving = false;
    this.is4K = false;
    this.focalPointModeOn = false;
    this.loadingFocalPoint = false;
    this.focalPointEnabled = false;
    this.beamPictureFormats = false;

    this.store.select("userState").subscribe((user: User) => {
      this.focalPointEnabled =
        user.currentLanguage.features.includes("FOCAL_POINT");

      this.beamPictureFormats =
        user.currentLanguage.features.includes("BEAM_PICTURE_FORMATS") ||
        this.data.type === "additional-pictures";
    });

    if (!this.data.optional2) {
      this.selectedIndex = 0;
    } else {
      if (data.type === "translate" || data.type === "event-article") {
        this.selectedIndex = this.indexes.indexOf(this.data.optional2);
      } else {
        this.selectedIndex = this.indexes.indexOf(this.data.id);
      }
    }

    this.subscriptions = [];
    if (data.type === "translate") {
      this.adminService.init().subscribe(() => {
        this.editMode = this.adminService.can("Translate", "Edit");
        this.getPictureDataForTranslate();
      });
    } else if (data.type === "event-article") {
      this.adminService.init().subscribe(() => {
        this.editMode = this.adminService.can("Event Article", "Edit");
        this.getPictureDataForEventArticle();
      });
    } else if (data.type === "event-additional-pictures") {
      this.adminService.init().subscribe(() => {
        this.editMode = this.adminService.can("Event Article", "Edit");
        this.getPictureDataForEventAdditionalPictures();
      });
    } else if (data.type === "additional-pictures") {
      this.adminService.init().subscribe(() => {
        this.editMode = this.adminService.can(
          "Program Article " + data.optional2,
          "Edit"
        );
        this.getPictureDataForAdditionalPictures();
      });
    } else {
      this.adminService.init().subscribe(() => {
        this.editMode = this.adminService.can(
          "Program Article " + data.optional,
          "Edit"
        );
        this.getPictureDataForProgramArticle();
      });
    }

    this.store.select("pictureFormatsState").subscribe((state: any) => {
      this.types = state.types;
    });
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.format = params.format;
    });
  }

  /**
   * Get the picture data from the translation according to the current language
   */
  getPictureDataForTranslate() {
    this.subscriptions.push(
      this.store.select("userState").subscribe((user: User) => {
        if (user && user.currentLanguage) {
          this.translationService
            .getTranslationById(
              this.data.id,
              this.data.optional,
              user.currentLanguage.id
            )
            .subscribe((translation) => {
              this.translation = translation;
              this.pictures = this.translation.pictures;
              this.loading = false;
            });
        }
      })
    );
  }

  /**
   * Get the picture data from the current program state in the store
   */
  getPictureDataForProgramArticle() {
    this.subscriptions.push(
      this.store
        .select("programArticlesState")
        .subscribe((programArticlesState: any) => {
          if (
            programArticlesState &&
            programArticlesState.currentProgramArticle
          ) {
            this.programArticle = programArticlesState.currentProgramArticle;
            // get picture clicked by user
            this.destination = this.programArticle.destinations.find(
              (d) => d.id === this.data.optional
            );
            this.pictures = this.destination.value.pictures;
            if (
              this.pictures &&
              this.pictures.length > 0 &&
              this.pictures[0].pictureURL
            )
              this.is4K = this.checkIfImageIs4k(this.pictures[0].pictureURL);
            this.loading = false;
          }
        })
    );
  }

  /**
   * Get the picture data from the event article according to the current language
   */
  getPictureDataForEventArticle() {
    this.subscriptions.push(
      this.store.select("userState").subscribe((user: User) => {
        if (user && user.currentLanguage) {
          this.currentLanguage = user.currentLanguage;
          this.eventArticleService
            .GetPictures(this.data.id, this.currentLanguage.id)
            .subscribe((pictures) => {
              this.pictures = pictures;
              this.loading = false;
            });
        }
      })
    );
  }

  /**
   * Get the picture data from the event article according to the current language
   */
  getPictureDataForAdditionalPictures() {
    this.subscriptions.push(
      this.store
        .select("additionalPicturesState")
        .subscribe((additionalPicturesState: any) => {
          if (additionalPicturesState && additionalPicturesState.pictureSets) {
            let setId = this.data.optional;
            this.pictures = [];
            if (
              additionalPicturesState.pictureSets.pictureSets.find(
                (ps) => ps.setId == setId
              )
            ) {
              this.pictures =
                additionalPicturesState.pictureSets.pictureSets.find(
                  (ps) => ps.setId == setId
                ).pictures;
            }
            this.selectedIndex = 0;
            this.loading = false;
          }
        })
    );
  }

  /**
   * Get the picture data from the event article according to the current language
   */
  getPictureDataForEventAdditionalPictures() {
    this.subscriptions.push(
      this.store
        .select("eventAdditionalPicturesState")
        .subscribe((eventAdditionalPicturesState: any) => {
          if (
            eventAdditionalPicturesState &&
            eventAdditionalPicturesState.pictureSets
          ) {
            let setId = this.data.optional;
            this.pictures = [];
            if (
              eventAdditionalPicturesState.pictureSets.pictureSets.find(
                (ps) => ps.setId == setId
              )
            ) {
              this.pictures =
                eventAdditionalPicturesState.pictureSets.pictureSets.find(
                  (ps) => ps.setId == setId
                ).pictures;
            }
            this.selectedIndex = 0;
            this.loading = false;
          }
        })
    );
  }

  /**
   * Check if an image is 4K resolution or higher.
   * @param imageUrl The URL of the image to check.
   * @returns True if the image is 4K or higher resolution, false otherwise.
   */
  checkIfImageIs4k(imageUrl: string) {
    const img = new Image();
    img.src = imageUrl;
    if (img.width >= 3840 && img.height >= 2160) return true;
    else return false;
  }

  /**
   * On picture click, simulate a click on the upload input
   */
  upload(event) {
    if (this.focalPointModeOn) {
      this.focalPointModeOn = false;
      this.loadingFocalPoint = true;

      this.customXPosition = event.offsetX;
      this.customYPosition = event.offsetY;

      this.focalPoint(this.cropper169, 1);
      const interval1 = setInterval(() => {
        clearInterval(interval1);
        this.focalPoint(this.cropper43, 2);
        const interval2 = setInterval(() => {
          clearInterval(interval2);
          this.focalPoint(this.cropper34, 3);
          const interval3 = setInterval(() => {
            clearInterval(interval3);
            this.focalPoint(this.cropper715, 4);
            const interval4 = setInterval(() => {
              clearInterval(interval4);
              this.focalPoint(this.cropper103, 5);
              const interval5 = setInterval(() => {
                clearInterval(interval5);
                this.focalPoint(this.cropper11, 6);
                const interval6 = setInterval(() => {
                  clearInterval(interval6);
                  this.focalPoint(this.cropper23, 7);
                  const interval7 = setInterval(() => {
                    clearInterval(interval7);
                    this.focalPoint(this.cropper31, 8);
                    const interval8 = setInterval(() => {
                      clearInterval(interval8);
                      this.selectedIndex = 0;
                      this.loadingFocalPoint = false;
                    }, 2000);
                  }, 2000);
                }, 2000);
              }, 2000);
            }, 2000);
          }, 2000);
        }, 2000);
      }, 2000);
    } else {
      document.getElementById("file_upload_cropper").click();
    }
  }

  focalPoint(cropper: PictureCropperComponent, index: number) {
    cropper.hasCustomPosition = true;
    cropper.customXPosition = this.customXPosition;
    cropper.customYPosition = this.customYPosition;
    cropper.editMode = true;
    cropper.edition = true;
    this.selectedIndex = index;
    cropper.loadImage();
  }
  /**
   * Handler the drop of picture
   */
  onDrop(event) {
    event.preventDefault();
    this.fileChange(event);
  }

  activateFocalPoint() {
    this.focalPointModeOn = !this.focalPointModeOn;
  }

  /**
   * Handler needed to activate the OnDrop Handler
   */
  onDragOver(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  /**
   * When a file is uploaded, load the data and check the size according to the minimal required size
   * @param event
   */
  fileChange(event) {
    if (
      (event.target.files && event.target.files[0]) ||
      (event.dataTransfer.files && event.dataTransfer.files[0])
    ) {
      this.loading = true;
      const file = event.target.files
        ? event.target.files[0]
        : event.dataTransfer.files[0];
      this.fileSize = Math.round((file.size / 1024 / 1024) * 100) / 100 + " MB";
      const reader = new FileReader();

      reader.addEventListener("load", () => {
        const image = new Image();
        image.src = reader.result as string;

        image.addEventListener("load", () => {
          this.changePicturesUrl(reader.result);
          this.newOriginal = reader.result as string;

          if (image.width > this.MAX_WIDTH || image.height > this.MAX_HEIGHT) {
            this.errorMessage =
              "Image is more than " +
              this.MAX_WIDTH +
              "x" +
              this.MAX_HEIGHT +
              " px are you sure you want to proceed?";
          }
          this.loading = false;
        });
      });

      reader.readAsDataURL(file);
    }
  }

  /**
   * Format the json and upload these data according to the picture type (program article or translation)
   */
  uploadPicture() {
    let translation = null;

    if (this.data.type === "translate") {
      translation = {
        id: this.translation.id,
        elementExternalId: this.translation["elementExternalId"],
        languageId: this.translation["languageId"],
        translationTypeId: this.translation["translationTypeId"],
        pictures: [],
      };
    } else {
      translation = { pictures: [] };
    }

    if (this.newOriginal) {
      translation.pictures.push({
        pictureURL: null,
        blob: this.newOriginal,
        pictureFormatCode: "Original",
        pictureFormatName: "Original",
      });
    } else {
      translation.pictures.push(
        this.pictures.find((p) => p.pictureFormatName === "Original")
      );
    }

    this.croppers.forEach((cropper) => {
      if (
        this.data.type === "additional-pictures" ||
        this.data.type === "event-additional-pictures" ||
        this.data.type === "translate" ||
        this.data.type === "event-article" ||
        (this.destination && this.destination.id !== "Popup Next")
      ) {
        let formatToSave = this.format.find(
          (f) => this.createFormatWithUnderscore(f) === cropper.format
        );
        if (formatToSave)
          translation.pictures.push({
            pictureURL: null,
            blob: cropper.image,
            pictureFormatCode: formatToSave,
            pictureFormatName: formatToSave,
          });
      }
    });

    this.saving = true;
    this.dialogRef.disableClose = true;
    this.errorMessage = null;

    if (this.data.type === "translate") {
      this.translationService.updatePictures(translation).subscribe((res) => {
        this.savingCallback(res);
      });
    } else if (this.data.type === "event-article") {
      this.eventArticleService
        .PostPictures([
          {
            sportingEventId: this.data.id,
            languageId: this.currentLanguage.id,
            pictures: translation.pictures,
          },
        ])
        .subscribe((res) => {
          this.eventArticlesActions.updateEventArticle(res);
          this.dialogRef.close();
        });
    } else if (this.data.type === "additional-pictures") {
      translation.pictures.forEach((element) => {
        element.isLocked = true;
      });
      this.format.forEach((item) => {
        this.additionalPicturesActions.updateAdditionalPictures(
          translation.pictures,
          this.data.optional,
          item
        );
      });
      this.dialogRef.close();
    } else if (this.data.type === "event-additional-pictures") {
      translation.pictures.forEach((element) => {
        element.isLocked = true;
      });
      this.format.forEach((item) => {
        this.eventAdditionalPicturesActions.updateEventAdditionalPictures(
          translation.pictures,
          this.data.optional,
          item
        );
      });
      this.dialogRef.close();
    } else {
      this.programArticlesActions.updateProgramArticlePicture(
        translation.pictures,
        this.data.optional
      );
      this.dialogRef.close();
    }
  }

  /**
   * Check the upload response from the server
   * @param res
   */
  savingCallback(res) {
    this.saving = false;
    this.dialogRef.disableClose = false;
    if (res.success === 1) {
      if (this.data.type === "translate") {
        this.translationsActions.updateTranslationPicture(
          new Translation(res.value)
        );
      }
      this.dialogRef.close();
    } else {
      this.errorMessage = res.message;
      setTimeout(() => (this.errorMessage = null), 5000);
    }
  }

  /**
   * Get the equinoxe picture from an ID and transform the response to a valid image data
   */
  getEquinoxePicture() {
    if (
      !this.equinoxeTerm ||
      this.equinoxeTerm.length < 1 ||
      this.equinoxeTerm.length > 9
    ) {
      return;
    }
    this.loading = true;
    this.pictureService.getPictureById(this.equinoxeTerm).subscribe(
      (res) => {
        if (res.value) {
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          const image = new Image();
          image.crossOrigin = "Anonymous";
          image.src = res.value.original.url;
          image.addEventListener("load", () => {
            let format169 = this.is4K
              ? this.types.type_4k.format_16_9
              : this.types.type_hd.format_16_9;

            if (
              image.width >= format169.width &&
              image.height >= format169.height
            ) {
              canvas.width = image.naturalWidth;
              canvas.height = image.naturalHeight;
              context.drawImage(image, 0, 0);
              const url = canvas.toDataURL("image/jpeg");
              this.errorMessage = null;
              this.changePicturesUrl(url);
              this.newOriginal = url;
              this.loading = false;
            } else {
              this.errorMessage =
                "Image too small, it must be at least " +
                format169.width +
                "x" +
                format169.height +
                " px";
              setTimeout(() => (this.errorMessage = null), 5000);
              this.loading = false;
            }
          });
        } else {
          this.errorMessage = "Equinoxe Image not found";
          setTimeout(() => (this.errorMessage = null), 5000);
          this.loading = false;
        }
      },
      () => (this.loading = false)
    );
  }

  /**
   * Unsubscribe all the subscriptions on destroy event
   */
  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  getETTPictureByFormat(format: string) {
    if (this.pictures.find((p) => p.pictureFormatName === format)) {
      return this.pictures.find((p) => p.pictureFormatName === format);
    } else {
      return { pictureUrl: "" };
    }
  }

  changePicturesUrl(url: any) {
    if (this.pictures.find((p) => p.pictureFormatName === "Original")) {
      this.pictures.find((p) => p.pictureFormatName === "Original").pictureURL =
        url;
    } else {
      // create original picture
      this.pictures.push(
        new ProgramArticlePictureETTValue({
          pictureURL: url,
          pictureFormatCode: "Original",
        })
      );
      if (this.programArticle) {
        this.pictures.find((p) => p.pictureFormatName === "Original").language =
          new Language({
            id: this.programArticle.language.id,
            value: this.programArticle.language.value,
          });
        this.pictures.find((p) => p.pictureFormatName === "Original").channel =
          new Channel({
            id: this.programArticle.channel.id,
            value: this.programArticle.channel.value,
          });
      }
    }

    // Refresh all formats
    this.indexes
      .filter((index) => index !== "Original")
      .forEach((index) => {
        if (this.pictures.find((p) => p.pictureFormatName === index)) {
          this.pictures.find((p) => p.pictureFormatName === index).pictureURL =
            null;
        }
      });
  }

  getWidthHeightFromFormat(format: string) {
    let widthHeight = this.is4K
      ? this.types.type_4k[format]
      : this.types.type_hd[format];
    return widthHeight.width + "x" + widthHeight.height;
  }

  changePictureType(event) {
    this.is4K = event.checked;
  }

  createCropperFormat(format: string) {
    return "cropper" + format.replace(":", "");
  }

  createFormatWithUnderscore(format: string) {
    return "format_" + format.replace(":", "_");
  }
}



// WEBPACK FOOTER //
// ./src/app/modals/cropper-picture-modal/cropper-picture-modal.component.ts